var styles = {
  "icon-on-color": "Polaris-Banner-BannerExperimental--iconOnColor",
  "icon-success-strong-experimental": "Polaris-Banner-BannerExperimental--iconSuccessStrongExperimental",
  "text-warning-strong": "Polaris-Banner-BannerExperimental--textWarningStrong",
  "icon-warning-strong-experimental": "Polaris-Banner-BannerExperimental--iconWarningStrongExperimental",
  "icon-critical-strong-experimental": "Polaris-Banner-BannerExperimental--iconCriticalStrongExperimental",
  "text-info-strong": "Polaris-Banner-BannerExperimental--textInfoStrong",
  "icon-info-strong-experimental": "Polaris-Banner-BannerExperimental--iconInfoStrongExperimental",
  "icon-subdued": "Polaris-Banner-BannerExperimental__icon--subdued"
};

export { styles as default };
